import AboutSection from "../components/AboutSection";
import BlogSection from "./BlogSelection";
import CustomerReviews from "../components/CustomerReviews";
import CustomerSupport from "../components/CustomerSupport";
import HeroSlider from "../components/HeroSlider";
import ProductsSection from "../components/ProductsSection";

export default function Home() {
  return (
    <div className="max-w-7xl mx-auto p-6">
      <HeroSlider />
      <ProductsSection />
      <AboutSection />
      <BlogSection />
      <CustomerReviews />
      <CustomerSupport />
    </div>
  );
}
